(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widget-hero-detail", [], factory);
	else if(typeof exports === 'object')
		exports["widget-hero-detail"] = factory();
	else
		root["widget-hero-detail"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1140);

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Spacings = exports.Spacings = {
	    NONE: 'none',
	    SMALL: 'small',
	    MEDIUM: 'medium',
	    BIG: 'big'
	};
	Object.freeze(Spacings);
	
	var SPACING_OPTIONS = exports.SPACING_OPTIONS = [{ label: 'None', value: Spacings.NONE }, { label: 'Spacing small', value: Spacings.SMALL }, { label: 'Spacing medium', value: Spacings.MEDIUM }, { label: 'Spacing big', value: Spacings.BIG }];
	
	var SPACING_PREF = exports.SPACING_PREF = 'spacing';

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Containers = exports.Containers = {
	    NONE: 'none',
	    REGULAR: 'regular'
	};
	Object.freeze(Containers);
	
	var CONTAINER_OPTIONS = exports.CONTAINER_OPTIONS = [{ label: 'None', value: Containers.NONE }, { label: 'Regular', value: Containers.REGULAR }];
	
	var CONTAINER_PREF = exports.CONTAINER_PREF = 'container';

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window, App */
	
	
	var _containers = __webpack_require__(360);
	
	var _spacings = __webpack_require__(359);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable-next-line no-unused-vars */
	var bd = window.bd;
	/* eslint-disable-next-line no-unused-vars */
	var be = window.be;
	/* eslint-disable-next-line no-unused-vars */
	var b$ = window.b$;
	
	var CxpWidget = function () {
	    function CxpWidget(widget) {
	        _classCallCheck(this, CxpWidget);
	
	        this.widget = widget;
	        this.widgetName = widget.id.replace(/-\d+$/, '');
	
	        this.widget.addEventListener('DOMReady', this.disableClickOnDevelop.bind(this));
	    }
	
	    _createClass(CxpWidget, [{
	        key: 'addHelpTexts',
	        value: function addHelpTexts(propertyKeyTextMap) {
	            var map = Object.keys(propertyKeyTextMap).reduce(function (map, key) {
	                map[key] = { text: propertyKeyTextMap[key] };
	                return map;
	            }, {});
	            this.widget.helpTexts = map;
	        }
	    }, {
	        key: 'onPreferencesSave',
	        value: function onPreferencesSave(event) {
	            // override
	        }
	    }, {
	        key: 'isManageable',
	        value: function isManageable() {
	            var isMasterpage = be && be.utils ? be.utils.module('top.bd.PageMgmtTree.selectedLink')['isMasterPage'] : false;
	            var isInCxpMode = bd.designMode; //Changed be.cmis
	            var isManageable = isInCxpMode && (isMasterpage || this.widget.model.manageable === 'true' || this.widget.model.manageable === '' || this.widget.model.manageable === undefined);
	            return isManageable;
	        }
	    }, {
	        key: 'canEditContent',
	        value: function canEditContent() {
	            /* todo: this is (also) from the backbase content widget, but as I see it, you can only edit the widget if
	            *  you're admin or the creator? Need to check, else change the role here.
	            *  */
	            return this.isManageable() && be.ice.controller && /(?:ADMIN|CREATOR|MANAGER)/.test(this.widget.model.securityProfile);
	        }
	    }, {
	        key: 'prepareCxpPreferences',
	        value: function prepareCxpPreferences() {
	            var _this = this;
	
	            this.widget.addEventListener('preferences-form', function (event) {
	                _this._populatePreferencesForm(event);
	                //*changed
	                if (_this.onCxpPreferencesForm) {
	                    var observer = new MutationObserver(function (mutations) {
	                        var prefForm = document.querySelector('#PreferenceEditorContent');
	                        if (prefForm) {
	                            observer.disconnect();
	                            _this.onCxpPreferencesForm(prefForm);
	                        }
	                    });
	                    observer.observe(document, { attributes: true, childList: true, subtree: true });
	                }
	            });
	            this.widget.addEventListener('preferencesSaved', function (event) {
	                _this.widget.refreshHTML();
	            });
	            this.widget.addEventListener('savePreferenceForm', function (event) {
	                _this.onPreferencesSave(event);
	            });
	        }
	    }, {
	        key: '_populatePreferencesForm',
	        value: function _populatePreferencesForm(event) {
	            var aPrefs = b$.portal.portalModel.filterPreferences(this.widget.model.preferences.array);
	            for (var i = aPrefs.length - 1; i >= 0; i--) {
	                var preferenceItem = aPrefs[i];
	                var prefKey = preferenceItem.name;
	
	                switch (prefKey) {
	                    case _spacings.SPACING_PREF:
	                        this._populateOptions(preferenceItem, _spacings.SPACING_OPTIONS);
	                        break;
	                    case _containers.CONTAINER_PREF:
	                        this._populateOptions(preferenceItem, _containers.CONTAINER_OPTIONS);
	                        break;
	                    default:
	                        this._populateListItems(preferenceItem);
	                }
	            }
	        }
	    }, {
	        key: '_populateOptions',
	        value: function _populateOptions(preferenceItem, options) {
	            preferenceItem.inputType.options = options.map(function (spacing) {
	                return {
	                    label: spacing.label,
	                    value: spacing.value
	                };
	            });
	        }
	    }, {
	        key: '_populateListItems',
	        value: function _populateListItems(preferenceItem) {
	            var prefKey = preferenceItem.name;
	            var sTemplateVariants = this.widget.getPreference(prefKey + 'List');
	
	            if (!sTemplateVariants) {
	                return;
	            }
	
	            var arr = sTemplateVariants.split(',');
	            for (var j = 0, k = 0; j < arr.length; j++, k++) {
	                preferenceItem.inputType.options[k] = {
	                    label: arr[j].trim(),
	                    value: arr[j + 1].trim()
	                };
	                j++;
	            }
	        }
	    }, {
	        key: 'disableClickOnDevelop',
	        value: function disableClickOnDevelop(event) {
	            if (App.Portal.isInDesignMode()) {
	                this.widget.body.querySelectorAll('a').forEach(function (a) {
	                    a.addEventListener('click', function (e) {
	                        return e.preventDefault();
	                    });
	                });
	            }
	        }
	    }]);
	
	    return CxpWidget;
	}();
	
	exports.default = CxpWidget;

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cxpConfig = __webpack_require__(569);
	
	var _cxpConfig2 = _interopRequireDefault(_cxpConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AbstractWidgetBaseController = function () {
	    function AbstractWidgetBaseController(widget) {
	        _classCallCheck(this, AbstractWidgetBaseController);
	
	        this.widget = widget;
	        this.widgetPath = window.App.Portal.getWidgetPath(this.widget);
	        this.cxpWidget = new _cxpConfig2.default(widget);
	    }
	
	    _createClass(AbstractWidgetBaseController, [{
	        key: 'getSelector',
	        value: function getSelector(query) {
	            return this.widget.body.querySelector(query);
	        }
	    }, {
	        key: 'getSelectors',
	        value: function getSelectors(query) {
	            return this.widget.body.querySelectorAll(query);
	        }
	    }]);
	
	    return AbstractWidgetBaseController;
	}();
	
	exports.default = AbstractWidgetBaseController;

/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(970);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* Created by Rowan de Zeeuw on 07/06/2018 */
	
	var CONTENT_REF = 'contentRef';
	var CONTENT_SERVICES_PROTOCOL = 'cs';
	var STRUCTURED_CONTENT_CLASS = 'bd-structured-content-ng';
	var $ = window.jQuery;
	
	var AbstractStructuredContentController = function (_AbstractWidgetBaseCo) {
	    _inherits(AbstractStructuredContentController, _AbstractWidgetBaseCo);
	
	    function AbstractStructuredContentController(widget, contentType) {
	        _classCallCheck(this, AbstractStructuredContentController);
	
	        var _this = _possibleConstructorReturn(this, (AbstractStructuredContentController.__proto__ || Object.getPrototypeOf(AbstractStructuredContentController)).call(this, widget));
	
	        if (_this.cxpWidget.isManageable()) {
	            _this.startDesignMode(contentType);
	            if (_this.cxpWidget.canEditContent()) {
	                _this.cxpWidget.prepareCxpPreferences();
	            }
	        }
	        return _this;
	    }
	
	    /* TODO: Modified Backbase code, should be prettified more. */
	
	
	    _createClass(AbstractStructuredContentController, [{
	        key: 'startDesignMode',
	        value: function startDesignMode(desiredContentType) {
	            var _this2 = this;
	
	            if (!desiredContentType) {
	                console.error('Content Type not defined');
	            }
	
	            var contentRef = this.widget.getPreference(CONTENT_REF);
	            var dragItem = void 0;
	            var $widget = $(this.widget.htmlNode);
	
	            if (!contentRef) {
	                $widget.addClass('bd-empty-structured-content');
	            } else {
	                $widget.addClass('bd-filled-structured-content');
	            }
	
	            $widget.append('<div class="' + STRUCTURED_CONTENT_CLASS + '"></div>');
	
	            $('.' + STRUCTURED_CONTENT_CLASS, $widget).attr('data-type', this.widget.getPreference('contentType') || 'Content');
	
	            this.widget.addEventListener('bdDrop.enter', function (e) {
	                dragItem = undefined;
	
	                var item = e.detail.info.helper.bdDragData.fileDataArray[0]; // e.detail.info.helper is a HTMLElement!@$#%
	
	                if (item.metaData && item.metaData['cmis:objectTypeId'] && item.metaData['cmis:objectTypeId'].property === 'bb:structuredcontent') {
	                    $widget.addClass('bd-over-structured-content');
	                    var droppedContentType = item.metaData['bb:typeDefinitionName'].property;
	                    if (desiredContentType && droppedContentType !== desiredContentType) {
	                        $widget.addClass('bd-over-structured-content-not-allowed');
	                        $widget[0].setAttribute('data-droperror', 'Content type [' + droppedContentType + '] not allowed, expected type [' + desiredContentType + ']');
	                    } else {
	                        dragItem = item;
	                    }
	                }
	            });
	            this.widget.addEventListener('bdDrop.leave', function (e) {
	                $widget.removeClass('bd-over-structured-content');
	                $widget.removeClass('bd-over-structured-content-not-allowed');
	                $widget[0].removeAttribute('data-droperror');
	            });
	            this.widget.addEventListener('bdDrop.drop', function (e) {
	                if (dragItem) {
	                    if (!_this2.widget.model.preferences.getByName(CONTENT_REF)) {
	                        var contentRefPref = window.b$.portal.portalModel.createPreference(CONTENT_REF, CONTENT_REF, undefined, '');
	                        _this2.widget.model.preferences.add(contentRefPref);
	                    }
	                    _this2.widget.setPreference(CONTENT_REF, [CONTENT_SERVICES_PROTOCOL, dragItem.repository === 'contentRepository' ? dragItem.repository : '@portalRepository', dragItem.contentUId].join(':'));
	                    _this2.widget.model.save(function () {
	                        _this2.widget.refreshHTML();
	                        $widget.removeClass('bd-empty-structured-content');
	                    });
	                    $widget.removeClass('bd-over-structured-content');
	                    $widget.removeClass('bd-over-structured-content-not-allowed');
	                    $widget[0].removeAttribute('data-droperror');
	                }
	                dragItem = undefined;
	            });
	
	            if (window.bd && window.bd.bindDropEvents) {
	                window.bd.bindDropEvents(this.widget.htmlNode);
	            }
	        }
	    }]);
	
	    return AbstractStructuredContentController;
	}(_controller2.default);
	
	exports.default = AbstractStructuredContentController;

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(1141);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	App.Widgets.setWidgetStarterInNamespace('WidgetHeroDetail', _controller2.default); /* global App */

/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constant = __webpack_require__(1142);
	
	var _controller = __webpack_require__(987);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Controller = function (_AbstractStructuredCo) {
	    _inherits(Controller, _AbstractStructuredCo);
	
	    function Controller(widget) {
	        _classCallCheck(this, Controller);
	
	        return _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, widget, _constant.CONTENT_TYPE_PRODUCT_INFO));
	    }
	
	    return Controller;
	}(_controller2.default);
	
	exports.default = Controller;

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONTENT_TYPE_PRODUCT_INFO = exports.CONTENT_TYPE_PRODUCT_INFO = 'product-info'; // model.xml name

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// widget-hero-detail/scripts/widget-hero-detail.js